import React from 'react';
import styles from './DashboardPage.module.css';

/**
 * Standard overview card used for Users, Feedback, and Security shortcuts.
 */
export default function OverviewStatCard({ icon: Icon, title, description, actionLabel, onAction }) {
    return (
        <div className={`${styles.statCard} island`}>
            <div className={styles.statIcon} aria-hidden='true'>
                <Icon />
            </div>
            <div className={styles.statInfo}>
                <h3>{title}</h3>
                <p className={styles.statCardDescription}>{description}</p>
                <button type='button' onClick={onAction} className={`btn btn-primary btn-sm ${styles.cardAction}`}>
                    {actionLabel}
                </button>
            </div>
        </div>
    );
}
